import { JourneyType } from 'app/constants/Booking/BookingConstants';

function getOutFunc() {
  const date = new Date()
  date.setMinutes(date.getMinutes() + 35, 0, 0)
  const minutes = date.getMinutes()
  const roundedMinutes = Math.ceil(minutes / 5) * 5
  date.setMinutes(roundedMinutes, 0, 0)
  return date
}

function getInFunc() {
  const date = new Date()
  const minutes = date.getMinutes()
  const roundedMinutes = Math.ceil(minutes / 5) * 5
  date.setMinutes(roundedMinutes, 0, 0)
  date.setDate(date.getDate() + 1)
  return date
}

export function formatDateAndTime(date = new Date()) {
  const minutes = date.getMinutes()
  const roundedMinutes = Math.ceil(minutes / 5) * 5
  date.setMinutes(roundedMinutes, 0, 0)
  return date
}

export default {
  journeyTypeName: JourneyType.ONE_WAY,
  outbound: {
    when: getOutFunc(),
    services: '',
    specialInstructions: '',
  },
  inbound: {
    when: getInFunc(),
    services: '',
    specialInstructions: '',
  },
}
